import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="announcement-period-confirm" (period step fieldset)
// Asks for a confirmation on submit when the chosen period puts the announcement online.
export default class extends Controller {
  static values = { message: String, modes: Array }

  connect() {
    this.form = this.element.closest("form")
    this.sync()
  }

  disconnect() {
    if (this.form) delete this.form.dataset.turboConfirm
  }

  sync() {
    if (!this.form) return

    const mode = this.element.querySelector('input[type="radio"]:checked')?.value
    if (this.modesValue.includes(mode)) {
      this.form.dataset.turboConfirm = this.messageValue
    } else {
      delete this.form.dataset.turboConfirm
    }
  }
}
